import { Box, Button, Stack, Typography } from '@dtx-company/design-system/src'
import { CardSliceContent } from '../../../types/prismic.types'
import { FC, useMemo } from 'react'
import { asText } from '@prismicio/client'
import { hexToRgb } from '@app/page/src/utils/theme'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import NextImage from 'next/image'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

export interface ProUpsellBannerProps {
  data: CardSliceContent
  sectionId?: string
}

export const ProUpsellBanner: FC<ProUpsellBannerProps> = ({ data, sectionId }) => {
  const { r, g, b } = useMemo(
    () => hexToRgb(data.card_background_color),
    [data.card_background_color]
  )
  const backgroundGradient = `linear-gradient(270deg, rgba(${r}, ${g}, ${b}, 0), rgba(${r}, ${g}, ${b}, 1))`

  return (
    <Stack
      id={sectionId}
      sx={{
        backgroundColor: data.card_background_color,
        pl: '80px',
        height: 'min-content'
      }}
      direction={'row'}
    >
      <Stack sx={{ maxWidth: '40%' }}>
        <Typography
          variant="headlineSmall"
          color={data.card_font_color}
          style={{ marginTop: '0.25rem' }}
        >
          {asText(data.title)}
        </Typography>
        <Typography
          variant="bodySmall"
          color={data.card_font_color}
          style={{ marginTop: '0.25rem' }}
        >
          {asText(data.description)}
        </Typography>
        {data.link.url && (
          <Box sx={{ my: 1 }}>
            <Button
              color={'inherit'}
              href={data.link.url}
              onClick={() => {
                events.Flowcode_LoggedOutGenerator_Clicked_LowerBannerText({
                  linkText: asText(data.link_text)
                })
              }}
            >
              {asText(data.link_text)}
            </Button>
          </Box>
        )}
      </Stack>

      <Box sx={{ width: '60%', borderWidth: '2px' }}>
        <Box sx={{ position: 'relative', width: '100%', minHeight: '150px' }}>
          {data.image.url && (
            <NextImage
              src={data.image.url}
              alt={data.image.alt || ''}
              loader={prismicImageLoader}
              fill
              sizes="50vw"
              style={{
                borderLeft: `2px solid ${data.card_background_color}`,
                objectFit: 'cover'
              }}
            />
          )}
          <Box
            sx={{
              position: 'absolute',
              background: backgroundGradient,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            }}
          />
        </Box>
      </Box>
    </Stack>
  )
}
